module.exports = __webpack_public_path__ + "static/media/buddies.4363275b.png";